import { customerCardReducer, customerSpdReducer } from '@makemydeal/dr-activities-customer-card';

import { customerCardMiddleware, customerCardActivityMiddleware } from './middleware';

/**
 * Customer Card activity: contributes store wiring only (reducers + middleware).
 * The card is rendered in-page by the Financing showroom content component,
 * so there is no route/routingComponent here.
 *
 * Two reducers: `reducer` (core card slice, `customerCard`) and `spdReducer` (SPD presence/status
 * slice, registered under `activitiesCustomerSpd`). Two middleware: `middleware` (the SCI bridge that
 * seeds the card) and `activityMiddleware` (the activity's own — fires the SPD CHECK on seed).
 */
export const customerCardConfiguration = {
    reducer: customerCardReducer,
    spdReducer: customerSpdReducer,
    middleware: customerCardMiddleware,
    activityMiddleware: customerCardActivityMiddleware
};
